<template>
    <b-container>
        <b-row>
            <b-col cols="12" md="8" class="mt-3">
                <ul v-for="(abono, index) in abonos" :key="index" class="resumen d-md-flex">
                    <li class="altcolor-content">
                        <div class="text-bold oswald text-uppercase m-0 w-100">
                            {{ ++index }}. {{ abono.precio.amount | formatear_precio }}
                        </div>
                    </li>
                    <li>
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ abono.zona.name }}
                        </div>
                    </li>
                    <li class="flex-grow-1">
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ $t('general.fila') }}: {{ abono.row }} - {{ $t('general.butaca') }}: {{ abono.seat }}
                        </div>
                    </li>
                    <li class="text-bold pr-0">
                        <label class="h5 pr-0">{{ $t('general.precio') }}</label>
                        <div class="h5 m-lg-0">
                            {{ getTotal(abono) | formatear_precio }}
                        </div>
                    </li>
                </ul>
                <div class="mb-5">
                    <label>{{ $t('evento.total_pagar') }}</label>
                    <div class="price price-large gradient-color">
                        {{ total_con_gastos | formatear_precio }}
                    </div>
                </div>
            </b-col>
            <b-col cols="12">
                <FormTerminos
                    :error="error"
                    :desactivar="loading"
                    @continuar="aceptarCondiciones"
                />
            </b-col>
            <ResumenPrecioComponent
                :price="total_sin_gastos"
                :price_management="total_gastos"
                :price_management_interno="abonos[0].precio.price_management_interno"
                :iva="footer.iva_partido"
            />
            <b-col cols="12" class="mt-3 d-flex justify-content-start flex-wrap">
                <button 
                    id="resumen-compra-responsive" 
                    :class="['button', 'effect-button', { 'large-button': !esMovil }]" 
                    :disabled="(formulario && pagar) || loading"
                    @click.prevent="terminar"
                >
                    <span>{{ $t('partido.continuar') }}</span>
                </button>
    
                <button
                    id="atras-resumen"
                    type="button"
                    :disabled="(formulario && pagar) || loading" 
                    :class="['button', 'effect-button', 'ml-2', 'compra-responsive', { 'large-button': !esMovil }]"
                    @click="$emit('volver')"
                >
                    <span>{{ $t('formularios.atras') }}</span>
                </button>
                <template v-if="formulario != null && pagar" >
                    <div id="formulario-compra" v-html="formulario" v-show="false"></div>
                </template>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent";

    export default {
        props: {
            abonos: {
                type: Array,
                required: true
            },
            jet_id: String,
            formulario: String
        },
        data() {
            return {
                pagar: false,
                error: false,
                loading: false,
                terminos: false,
                privacidad: false,
                condiciones: false,
                comunicaciones: false
            }
        },
        methods: {
            terminar() {
                if (this.terminos) {
                    this.guardarTerminosCondiciones();
                    this.pagar = true;

                    if (this.formulario && this.pagar) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 500);
                    } else {
                        this.$emit('terminado');
                    }

                    this.loading = false;
                } else {
                    this.error = true;
                    this.loading = false;
                }
            },
            getTotal(abono, con_gastos) {
                let precioSeleccionado = abono.precio;
                let precio = precioSeleccionado.amount;

                if (con_gastos && !precioSeleccionado.price_management_online) {
                    precio += precioSeleccionado.price_management;
                }

                return precio;
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                if (continuar == true) {
                    this.terminos = true;
                    
                    this.privacidad = privacidad;
                    this.condiciones = condiciones;
                    this.comunicaciones = comunicaciones;
                } else {
                    this.terminos = false;
                }
            },
            guardarTerminosCondiciones() {
                this.loading = true;

                const data = {
                    filters: {},
                    cart_id: this.sga_abono_cart_id,
                    privacidad: this.privacidad,
                    condiciones: this.condiciones,
                    comunicaciones: this.comunicaciones
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.guardar-condiciones'), data);
            }
        },
        computed: {
            sga_abono_cart_id() {
                return parseInt(localStorage.getItem('sga_abono_cart_id'));
            },
            esMovil() {
                return window.innerWidth <= 768;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            total_con_gastos() {
                let total = 0;

                this.abonos.forEach(abono => {
                    total += this.getTotal(abono, true);
                });

                return total;
            },
            total_sin_gastos() {
                let total = 0;

                this.abonos.forEach(abono => {
                    total += this.getTotal(abono, false);
                });

                return total;
            },
            total_gastos() {
                let total = 0;

                this.abonos.forEach(abono => {
                    let precio = abono.precio;

                    if (!precio.price_management_interno) {
                        total += precio.price_management;
                    }
                })

                return total;
            }
        },
        components: {
            FormTerminos, ResumenPrecioComponent
        }
    } 
</script>